/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CallControlsConfigEntity } from './CallControlsConfigEntity.js';
import {
    CallControlsConfigEntityFromJSON,
    CallControlsConfigEntityFromJSONTyped,
    CallControlsConfigEntityToJSON,
} from './CallControlsConfigEntity.js';
import type { CustomerStatus } from './CustomerStatus.js';
import {
    CustomerStatusFromJSON,
    CustomerStatusFromJSONTyped,
    CustomerStatusToJSON,
} from './CustomerStatus.js';
import type { ProductCatalogConfig } from './ProductCatalogConfig.js';
import {
    ProductCatalogConfigFromJSON,
    ProductCatalogConfigFromJSONTyped,
    ProductCatalogConfigToJSON,
} from './ProductCatalogConfig.js';
import type { TenantConfigEntity } from './TenantConfigEntity.js';
import {
    TenantConfigEntityFromJSON,
    TenantConfigEntityFromJSONTyped,
    TenantConfigEntityToJSON,
} from './TenantConfigEntity.js';

/**
 * 
 * @export
 * @interface TenantConfig
 */
export interface TenantConfig {
    /**
     * 
     * @type {ProductCatalogConfig}
     * @memberof TenantConfig
     */
    productCatalogConfig?: ProductCatalogConfig;
    /**
     * 
     * @type {CallControlsConfigEntity}
     * @memberof TenantConfig
     */
    callControlsConfig?: CallControlsConfigEntity;
    /**
     * 
     * @type {TenantConfigEntity}
     * @memberof TenantConfig
     */
    globalConfig?: TenantConfigEntity;
    /**
     * 
     * @type {Array<CustomerStatus>}
     * @memberof TenantConfig
     */
    customerStatusConfig?: Array<CustomerStatus>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TenantConfig
     */
    accountRolesConfig?: { [key: string]: number; };
}

/**
 * Check if a given object implements the TenantConfig interface.
 */
export function instanceOfTenantConfig(value: object): boolean {
    return true;
}

export function TenantConfigFromJSON(json: any): TenantConfig {
    return TenantConfigFromJSONTyped(json, false);
}

export function TenantConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'productCatalogConfig': json['productCatalogConfig'] == null ? undefined : ProductCatalogConfigFromJSON(json['productCatalogConfig']),
        'callControlsConfig': json['callControlsConfig'] == null ? undefined : CallControlsConfigEntityFromJSON(json['callControlsConfig']),
        'globalConfig': json['globalConfig'] == null ? undefined : TenantConfigEntityFromJSON(json['globalConfig']),
        'customerStatusConfig': json['customerStatusConfig'] == null ? undefined : ((json['customerStatusConfig'] as Array<any>).map(CustomerStatusFromJSON)),
        'accountRolesConfig': json['accountRolesConfig'] == null ? undefined : json['accountRolesConfig'],
    };
}

export function TenantConfigToJSON(value?: TenantConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'productCatalogConfig': ProductCatalogConfigToJSON(value['productCatalogConfig']),
        'callControlsConfig': CallControlsConfigEntityToJSON(value['callControlsConfig']),
        'globalConfig': TenantConfigEntityToJSON(value['globalConfig']),
        'customerStatusConfig': value['customerStatusConfig'] == null ? undefined : ((value['customerStatusConfig'] as Array<any>).map(CustomerStatusToJSON)),
        'accountRolesConfig': value['accountRolesConfig'],
    };
}

